import React from 'react';
import { Label } from '~/lib/ui/label';
import { Switch } from '~/lib/ui/switch';
import { PopupQuestionMarkHelper } from '../popupQuestionMark';
import { SwitchWithLabelProps } from './index.types';

/**
 * SwitchWithLabel - Toggle component for Settings pages.
 *
 * Displays a switch with an associated label and optional helper text.
 * Fully accessible via keyboard and screen readers.
 * Used to update user preferences across Settings pages.
 *
 * @param id - Unique identifier for the switch and its label
 * @param label - Text displayed next to the switch
 * @param checked - Current state of the switch
 * @param onChange - Callback fired when the switch changes state
 * @param helperText - Optional helper text displayed in the question mark popover
 * @param testid - Identifier used for testing purposes
 */

export const SwitchWithLabel: React.FC<SwitchWithLabelProps> = ({
  id,
  label,
  checked,
  onChange,
  helperText,
  testid,
}) => {
  return (
    <div className="flex items-center justify-between">
      <div className="flex items-center gap-1">
        <Switch
          id={id}
          checked={checked}
          onCheckedChange={onChange}
          data-testid={testid}
          className="scale-125"
        />
        <Label htmlFor={id} className="text-lg font-medium cursor-pointer ml-6">
          {label}
        </Label>
        {helperText && (
          <PopupQuestionMarkHelper testid={testid} content={helperText} />
        )}
      </div>
    </div>
  );
};